import PropTypes from "prop-types";
import { classNamePropType } from "../../common";

/**
 * PropTypes for RichtextRenderer component
 * @typedef {Object} RichtextRendererProps
 * @property {string} content - HTML/richtext content to render
 * @property {string} [className] - Optional CSS class name
 */
export const richtextRendererPropTypes = {
  content: PropTypes.string.isRequired,
  className: classNamePropType,
};
